/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { GUEST_PROFILES_SAMPLE } from '../../../constants/appConstants';

/* Components */
import UCModal from "../../ucmodal";
import GuestProfilesDropzone from "../../peopleTabbedNav/guestTab/dropzone";

/* Styles */
import styles from "./styles";

const BulkUploadGuestProfilesModal = ({showModal, setShowModal, getGuestProfilesAction}) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const [isUploading, setIsUploading] = useState(false);
  const getApiSample = () => GUEST_PROFILES_SAMPLE || '';

  return (
    <UCModal
      className={ `${classes.modal} ${isUploading ? classes.disableClose : ""}` }
      showModal={ showModal }
      setShowModal={ setShowModal }
      modalHeaderTitle={
        <FormattedMessage id="guestHeader.modalUpload.title"/>
      }
      modalDescription={
        <p className={classes.description}>
          <FormattedMessage id="guestHeader.modalUpload.description" />
          <a href={getApiSample()} download="GuestProfilesList.csv" target='_blank' className={classes.download}>
            <FormattedMessage id="guestHeader.modalUpload.download" />
          </a>
        </p>
      }
      modalContent={
        <>
          <div className={classes.dropzone}>
            <GuestProfilesDropzone setShowModal={setShowModal} isUploading={isUploading} setIsUploading={setIsUploading} callback={getGuestProfilesAction}/>
          </div>
        </>
      }
      dataTestId="uploadguestprofilesnmodal"
    />
  )
}

export default BulkUploadGuestProfilesModal;
